<template>
  <div class="container-fluid" style="color:#FFF; padding: 10px;">
    <h2>{{ title }}</h2>
    <p>{{ description }}</p>
  </div>
</template>

<script>
export default {
  props: ["description", "title"],
  name: "SitesOffline"
};
</script>
